import React from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import { Helmet } from 'react-helmet'
import BackButton from '../../../components/BackButton'
import hours from '../../../contants/hours'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
function CreateHoliday() {
    const saveForm = useForm()
    const navigate = useNavigate()
    const { token } = useSelector((state) => state.auth)

    const saveSubmit = (data) => {
        data.openTime = moment(data.openTime, 'HH:mm').format('HH:mm')
        data.closeTime = moment(data.closeTime, 'HH:mm').format('HH:mm')
        data.allDay = Boolean(parseInt(data.allDay))
        axios.post(`${process.env.REACT_APP_SERVICE_URL}/holiday`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal("Tatil başarıyla oluşturuldu", {
                    icon: "success",
                });
                navigate(-1)
            })
            .catch((error) => {
                console.error(error)
                swal("Tatil oluşturulurken bir hata oluştu", {
                    icon: "error",
                });
            })
    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Tatil Oluştur</title>
                <meta name='description' content='Tatil Oluştur' />
            </Helmet>
            <HeaderTitle title='Tatil Oluştur' description={'Tatil Oluştur'} />

            <div className='row'>
                <div className='col-md-4'>
                    <div className='card card-body'>
                        <BackButton />
                        <form className='mt-3' onSubmit={saveForm.handleSubmit(saveSubmit)}>
                            <div className='mb-3'>
                                <label className='form-label'>Tarih</label>
                                <input
                                    type='date'
                                    name="date"
                                    {...saveForm.register('date', { required: true })}
                                    className='form-control' min={new Date().toISOString().split('T')[0]} />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Tüm Gün</label>
                                <select className='form-select' name='allDay' {...saveForm.register('allDay', { required: true })}>
                                    <option value='1'>Evet</option>
                                    <option value='0'>Hayır</option>
                                </select>
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Başlangıç Saati</label>
                                <select className='form-select' name='openTime' {...saveForm.register('openTime', { required: true })}>
                                    {
                                        hours.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })
                                    }
                                </select>
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Bitiş Saati</label>
                                <select className='form-select' name='closeTime' {...saveForm.register('closeTime', { required: true })}>
                                    {
                                        hours.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })
                                    }
                                </select>
                            </div>

                            <div className=''>
                                <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateHoliday